// extracted by mini-css-extract-plugin
module.exports = {"note":"ContentReviewNote_note__kIGHe"};